module.exports = __webpack_public_path__ + "static/img/ActiveBuilder.781eb91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui/reports/ActiveBuilder.png
// module id = LEJg
// module chunks = 1